// @flow
import * as React from 'react';
import { Typography } from '@mui/material';
import { useAgent, useAgentCallAgenda } from '../../../shared';


export const AssignedToOtherAgentNotification = ({clientId}: {clientId?: string}) => {
  const agent = useAgent();
  const {state} = useAgentCallAgenda();
  const assigned = state?.tasks.some(t => (
    t.clientId === clientId && !t.completed && !!t.currentAssignment?.assignedAgentId && t.currentAssignment?.assignedAgentId !== agent?.id
  ));

  if (!assigned) {
    return null;
  }

  return (
    <Typography align={'center'} color={'#fff'} sx={{background: 'linear-gradient(90deg, rgba(234, 234, 234, 1) 0%, rgba(243, 112, 40, 1) 2%, rgba(243, 112, 40, 1) 98%, rgba(234, 234, 234, 1) 100%)', py: .5}} variant={'body2'}>
      This client assigned to other agent.
    </Typography>
  );
};
